// extracted by mini-css-extract-plugin
module.exports = {"preview":"Preview_preview__AIzSx","controlPrev":"Preview_controlPrev__1wFjn","controlNext":"Preview_controlNext__1kF83","slideNumber":"Preview_slideNumber__Ptfpy"};